import React from 'react'
import ErrorView from 'app/components/ErrorView'
import PropTypes from 'prop-types'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error(error.stack || error)
    return { hasError: true }
  }

  // to do arg. error
  componentDidCatch(_, errorInfo) {
    // You can also log the error to an error reporting service
    if (process.env.NODE_ENV === 'development') {
      console.error(errorInfo.componentStack)
    }
  }

  render() {
    return this.state.hasError
      ? this.props.fallback || <ErrorView />
      : this.props.children
  }
}

ErrorBoundary.propTypes = {
  fallback: PropTypes.element,
}
